// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "messages.proto" (syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class Heartbeat$Type extends MessageType {
    constructor() {
        super("Heartbeat", [
            { no: 1, name: "nodeId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Heartbeat
 */
export const Heartbeat = new Heartbeat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Leave$Type extends MessageType {
    constructor() {
        super("Leave", [
            { no: 1, name: "nodeId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Leave
 */
export const Leave = new Leave$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViewerInfo$Type extends MessageType {
    constructor() {
        super("ViewerInfo", [
            { no: 1, name: "viewerCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ViewerInfo
 */
export const ViewerInfo = new ViewerInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message$Type extends MessageType {
    constructor() {
        super("Message", [
            { no: 1, name: "messageId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mediaPacketFragment", kind: "message", oneof: "body", T: () => MediaPacketFragment },
            { no: 3, name: "heartbeat", kind: "message", oneof: "body", T: () => Heartbeat },
            { no: 4, name: "leave", kind: "message", oneof: "body", T: () => Leave },
            { no: 5, name: "ViewerInfo", kind: "message", jsonName: "ViewerInfo", oneof: "body", T: () => ViewerInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Message
 */
export const Message = new Message$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoFrame$Type extends MessageType {
    constructor() {
        super("VideoFrame", [
            { no: 1, name: "frameNumber", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "duration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "isKeyFrame", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "screenOrientation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 8, name: "extradata", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 9, name: "codedWidth", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "codedHeight", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "codec", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "isScreenSharing", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "videoOrientation", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message VideoFrame
 */
export const VideoFrame = new VideoFrame$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioFrame$Type extends MessageType {
    constructor() {
        super("AudioFrame", [
            { no: 1, name: "frameNumber", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "duration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "isKeyFrame", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 6, name: "extradata", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AudioFrame
 */
export const AudioFrame = new AudioFrame$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MediaPacket$Type extends MessageType {
    constructor() {
        super("MediaPacket", [
            { no: 1, name: "packetNumber", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "videoCodec", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "videoMetadata", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "videoFrames", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoFrame },
            { no: 5, name: "audioCodec", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "audioMetadata", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 7, name: "audioFrames", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AudioFrame },
            { no: 8, name: "mediaStreamId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message MediaPacket
 */
export const MediaPacket = new MediaPacket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MediaPacketFragment$Type extends MessageType {
    constructor() {
        super("MediaPacketFragment", [
            { no: 1, name: "packetNumber", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "fragmentNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "numberOfFragments", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message MediaPacketFragment
 */
export const MediaPacketFragment = new MediaPacketFragment$Type();
